__turbopack_context__.v({
  "loginLink": "Header-module__DSiHbG__loginLink",
  "navigationContainer": "Header-module__DSiHbG__navigationContainer",
});
